import { useEffect, useRef, useState } from 'react';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { getContracts } from '../../../services/contracts.service';
import { ContractDto } from '../../../services/dtos/contract.dto';
import { showAxiosMessageError } from '../../../services/error-message.service';
import MyConsommationsUi from '../../../components/user-interfaces/my-consommations/my-consommations.ui';

/**
 * Page mes factures, comportant toutes les factures de tous les contrats
 * @constructor
 */
export default function MyConsommationsPage() {
    //Permet de savoir si on est passé une fois dans l'useEffect
    const dataFetchedRef = useRef(false);
    const showMessage = useSnackbars();
    const errorMessage = 'Erreur lors de la récupération des contrats.';
    const [contracts, setContracts] = useState<Array<ContractDto>>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [isSearching, setIsSearching] = useState<boolean>(true);

    /**
     * Récupération des contrats associés à l'utilisateur connecté
     */
    useEffect(() => {
        // Pour éviter de passer deux fois dans la requete
        if (dataFetchedRef.current) {
            return;
        }
        dataFetchedRef.current = true;
        setContracts([]);
        setLoading(true);
        getContracts()
            .then(fetchedContracts => {
                fetchedContracts.forEach(contract => {
                    if (contract['@id'] && typeof contract['@id'] === 'string') {
                        contract['@id'] = contract['@id'].replace('/rattachement_contrats/', '');
                    }
                });
                // Formattage de tous les contrats pour supprimer l'url de leur id
                const data = fetchedContracts.slice().sort((a, b) => (a?.contrat > b?.contrat ? 1 : -1));
                setContracts(data);
                setLoading(false);
                setIsSearching(false);
            })
            .catch(error => {
                setLoading(false);
                setIsSearching(false);
                console.error(errorMessage);
                showAxiosMessageError(error, showMessage);
            });
        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <MyConsommationsUi loading={loading} contracts={contracts} isSearching={isSearching} />;
}
